import { useSelector, useDispatch } from "react-redux";
import { Box, Typography } from "@mui/material";
import { RootState } from "system/store";
import { policyEditorActions } from "system/store/slices/policy-editor-slice";
import { ApplicabilityRuleBuilder } from "./ApplicabilityRuleBuilder";

const ApplicabilityRuleTab = ({ readOnlyViewer }: { readOnlyViewer: boolean }) => {
  const dispatch = useDispatch();
  const selectedPackage = useSelector((state: RootState) => state.policyEditor.selectedPackage);

  if (!selectedPackage) return null;

  const { rule, isUpdating } = selectedPackage;

  const handleBuilderChange = (result: {
    finalValue: string;
    finalDelimiter: string;
    comment: string;
    fullSyntax: string;
    isValid: boolean;
  }) => {
    dispatch(
      policyEditorActions.updateSelectedPackageField({
        field: "value",
        value: result.finalValue,
      })
    );
    dispatch(
      policyEditorActions.updateSelectedPackageField({
        field: "delimiter",
        value: result.finalDelimiter,
      })
    );
    dispatch(
      policyEditorActions.updateSelectedPackageField({
        field: "inlineComment",
        value: result.comment,
      })
    );

    dispatch(policyEditorActions.updateSelectedPackageIsValid(result.isValid));
  };

  return (
    <Box sx={{ color: "#fff" }}>
      <Typography variant="h6" sx={{ marginBottom: 2 }}>
        Applicability Rule
      </Typography>
      <ApplicabilityRuleBuilder
        initialName={rule.name}
        initialDelimiter={rule.delimiter}
        initialValue={rule.value}
        initialComment={rule.inlineComment ?? ""}
        isUpdating={isUpdating}
        onChange={handleBuilderChange}
        readOnlyViewer={readOnlyViewer}
      />
    </Box>
  );
};

export default ApplicabilityRuleTab;
